module.exports = __webpack_public_path__ + "images/assets/8fedcf7d58e926e928b106f7b0f8ea7f.svg";